import { QFilterGeneric } from './QFilterGeneric'

export class QFilterBPInclude extends QFilterGeneric {
  name = "business_process_include";
  class_name = "QFilterBPInclude";
  api_name= 'business_process_include';
  
  serialize(qfilters) {
    return encodeURIComponent(this.value);
  }
}
